import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityStatements from "./statements/UserPageIdentityStatements";
import UserPageIdentityHeader from "./header/UserPageIdentityHeader";
import { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import ProfileRatersTableWrapper, { ProfileRatersParams } from "../utils/raters-table/wrapper/ProfileRatersTableWrapper";
import UserPageIdentityActivityLog from "./activity/UserPageIdentityActivityLog";
export default function UserPageIdentity(t0) {
  const $ = _c(17);
  const {
    profile,
    initialCICReceivedParams,
    initialCICGivenParams,
    initialActivityLogParams
  } = t0;
  let t1;
  let t2;
  if ($[0] !== profile) {
    t1 = <UserPageIdentityHeader profile={profile} />;
    t2 = <UserPageIdentityStatements profile={profile} />;
    $[0] = profile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== initialCICGivenParams) {
    t3 = <ProfileRatersTableWrapper initialParams={initialCICGivenParams} />;
    $[3] = initialCICGivenParams;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialCICReceivedParams) {
    t4 = <ProfileRatersTableWrapper initialParams={initialCICReceivedParams} />;
    $[5] = initialCICReceivedParams;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-mt-6 lg:tw-mt-10 xl:tw-flex xl:tw-items-stretch tw-space-y-8 lg:tw-space-y-10 xl:tw-space-y-0 tw-gap-x-8">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== initialActivityLogParams) {
    t6 = <div className="tw-mt-8 lg:tw-mt-10"><UserPageIdentityActivityLog initialActivityLogParams={initialActivityLogParams} /></div>;
    $[10] = initialActivityLogParams;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="tailwind-scope">{t1}{t2}{t5}{t6}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}